export enum DocumentEnum {
    SERVICES = "services",
    ORDERS = "orders",
    DELIVERY = "delivery",
    INVOICES = "invoices",
    INVOICES_MAS = "invoicesmas",
    INVOICES_DEAL = "invoicesdeal"
}